import { DateTime } from 'luxon';

export const useDateRanges = () => {
  const currentDate = DateTime.now().setZone('America/Mexico_City').toFormat('dd.MM.yyyy');
  const previousDate = DateTime.now()
    .setZone('America/Mexico_City')
    .minus({ days: 1 })
    .toFormat('dd.MM.yyyy');
  const last7DaysRange = `${DateTime.now().setZone('America/Mexico_City').minus({ days: 7 }).toFormat('dd.MM.yyyy')} to ${currentDate}`;
  const last30DaysRange = `${DateTime.now().setZone('America/Mexico_City').minus({ days: 30 }).toFormat('dd.MM.yyyy')} to ${currentDate}`;

  return {
    currentDate,
    previousDate,
    last7DaysRange,
    last30DaysRange
  };
};
